<template>
  <div>
    <div>
      <v-icon
        class="handle"
        small
        left
      >
        drag_handle
      </v-icon>
      <v-chip
        v-if="id"
        small
        label
        style="text-transform:capitalize;"
      >
        {{ atomicType }}
      </v-chip>
      <v-select
        v-if="!id"
        :value="atomicType"
        :items="atomicTypeOptions"
        :item-value="'value'"
        :item-text="'name'"
        hide-details
        dense
        style="display:inline-block;max-width:125px;"
        @change="$emit('update:atomicType', arguments[0])"
      />
      <v-text-field
        :value="text"
        hide-details
        type="text"
        style="display:inline-block;margin-bottom:4px;"
        @input="$emit('update:text', arguments[0])"
      />
      <v-checkbox
        v-model="requiredValue"
        label="Required"
        style="display:inline-block;margin:0;margin-bottom:4px;margin-left:50px;"
        @change="$emit('update:required', arguments[0] || false)"
      />
      <a v-if="showOptionListBuilder || showRegexBuilder"
        @click="hideSubfieldDetails=!hideSubfieldDetails">
        <span v-if="!hideSubfieldDetails"><small>Hide Subfield Details</small></span>
        <span v-if="hideSubfieldDetails"><small>Show Subfield Details</small></span>
      </a>
      <span
        v-if="viewIdentifiers && id"
        style="padding-left:20px;font-family:monospace;font-size:10px"
      >
        Q-{{questionId}} F-{{id}} FCLID-{{ fieldTypeCLID }} <v-btn v-if="!editing" @click="editing = true">Edit</v-btn>
        <v-layout v-if="editing" row>
          <v-flex sm6>
            <v-text-field
              v-if="editing"
              v-model="editFieldTypeCLID"
              label="Fieldtype CLID"
              style="margin-right: 10px;"
              :rules="clidRule"
            />
          </v-flex>
          <v-flex sm4 style="font-family: Roboto, sans-serif;">
            <v-btn
              color="info"
              @click="$emit('update:fieldTypeCLID', editFieldTypeCLID);editing=false"
            >
              Save
            </v-btn>
            <v-btn 
              style="font-family: Roboto, sans-serif;"
              @click="editing=false;editFieldTypeCLID = fieldTypeCLID"
            >
              Cancel
            </v-btn>
          </v-flex>
        </v-layout>
      </span>
      <OptionListBuilder
        v-if="showOptionListBuilder"
        v-show="!hideSubfieldDetails"
        ref="optionListBuilder"
        :value="optionListId"
        @input="$emit('update:optionListId', arguments[0])"
        @loading="$emit('loading', arguments[0])"
        @changed="$emit('changed')"
      />
      <div
        v-if="showRegexBuilder"
        v-show="!hideSubfieldDetails"
      >
        <v-card>
          <v-card-text>
            <v-select
              v-if="!id"
              :items="GlobalRegexPatterns"
              label="Select a pattern"
              item-text="name"
              return-object
              @change="updatePattern($event)"
            />
            <v-text-field
              :value="maskPattern"
              :disabled="disabledRegexFields"
              label="Mask Pattern"
              @input="$emit('update:maskPattern', arguments[0])"
            />
            <v-text-field
              :value="regexPattern"
              :disabled="disabledRegexFields"
              label="Regex Validation Pattern"
              @input="$emit('update:regexPattern', arguments[0])"
            />
            <v-text-field
              :value="validationMessage"
              :disabled="disabledRegexFields"
              label="Validation Error Message"
              @input="$emit('update:validationMessage', arguments[0])"
            />
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OptionListBuilder from './OptionListBuilder'
import GlobalConstants from '@/globals'

export default {
  name: 'SubFieldType',
  props: [ 'id', 'atomicType', 'optionListId', 'text', 'questionId', 'required', 'validationMessage', 'regexPattern', 'maskPattern', 'fieldTypeCLID' ],
  components: {
    OptionListBuilder
  },
  data () {
    return {
      GlobalConstants: null,
      GlobalRegexPatterns: GlobalConstants.GlobalRegexPatterns,
      atomicTypeOptions: GlobalConstants.AtomicFieldTypes,
      hideSubfieldDetails: (this.id !== null),
      requiredValue: JSON.parse(JSON.stringify(this.required)),
      disabledRegexFields: false,
      editing: false,
      editFieldTypeCLID: "",
      clidRule: [
        value => !!value || 'A CLID is required',
        value => value.length <= 20 || "CLID needs to be 20 or less characters long"
      ]
    }
  },
  mounted () {
    this.editFieldTypeCLID = this.fieldTypeCLID
  },
  computed: {
    ...mapState('formtemplate', [
      'viewIdentifiers'
    ]),
    showOptionListBuilder () {
      return (this.atomicType === 'dropdown' || this.atomicType === 'checkbox' || this.atomicType === 'radio')
    },
    showRegexBuilder () {
      return this.atomicType === 'regex'
    }
  },
  methods: {
    save () {
      this.$emit('loading', true)
      if (this.showOptionListBuilder) {
        return this.$refs.optionListBuilder.save()
      } else {
        return Promise.resolve()
      }
    },
    updatePattern (event) {
      this.$emit('update:validationMessage', event.validation_message)
      this.$emit('update:regexPattern', event.regex_pattern)
      this.$emit('update:maskPattern', event.mask_pattern)
      this.disabledRegexFields = event.name !== "Custom Pattern"
    },
  }
}
</script>
